import { Guid } from "guid-typescript";
import { FetchInterceptor } from "src/app/helpers/Index";
import { SponsorshipType } from "src/app/interfaces/Index";
import { environment } from "src/environments/environment";
import { Partner } from "../interfaces/Partner";
import { Service } from "./Service";

const endpoint = "Partner";
export const PartnerService = {
	endpoint,
	createSingle: async (data: Partner) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getScoreboard: async () => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/GetScoreboard`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: Partner) => await Service.updateSingleById(endpoint, id, data),
}